import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {ReachTemplate, ReachTemplateCreatePayload} from "./types";
import {AUDIENCES_QUERY_KEY, RESOURCE_USAGES_QUERY_KEY, TEMPLATES_QUERY_KEY} from "../queryKeys";

const createTemplate = async (payload: ReachTemplateCreatePayload): Promise<ReachTemplate> => {
  const response = await axiosReachInstance.post<
    ReachTemplate,
    AxiosResponse<ReachTemplate>,
    ReachTemplateCreatePayload
  >("/templates", payload);
  return response.data;
};

export const useCreateTemplate = (
  options?: BaseMutationOptions<ReachTemplate, ReachTemplateCreatePayload>
): BaseUseMutationResult<ReachTemplate, ReachTemplateCreatePayload> => {
  return useBaseMutation<ReachTemplate, ReachTemplateCreatePayload>(createTemplate, {
    ...options,
    prefixKeysToReset: () => [[TEMPLATES_QUERY_KEY], [AUDIENCES_QUERY_KEY], [RESOURCE_USAGES_QUERY_KEY]],
  });
};
